import { useEffect } from 'react';

// Jedes Datei-Feld (label/Box mit input[type=file]) nimmt Dateien per Drag & Drop an – app-weit, ohne Einzelanpassung
export const dateiFeld = (el) => {
  const box = el?.closest?.('label, [data-datei-ziel]');
  if (!box || box.closest('[data-eigene-ablage]')) return null;
  const input = box.querySelector('input[type="file"]');
  return input && !input.disabled ? { box, input } : null;
};

const passt = (f, accept) => {
  if (!accept) return true;
  const name = f.name.toLowerCase();
  return accept.split(',').map((a) => a.trim().toLowerCase()).filter(Boolean).some((a) => (a.startsWith('.') ? name.endsWith(a) : a.endsWith('/*') ? (f.type || '').startsWith(a.slice(0, -1)) : f.type === a));
};

const KLASSE = 'lf-drop-ueber';

export const DateiFelderDrop = () => {
  useEffect(() => {
    let aktiv = null;
    const markieren = (box) => { if (aktiv === box) return; aktiv?.classList.remove(KLASSE); aktiv = box; box?.classList.add(KLASSE); };
    const istDatei = (e) => [...(e.dataTransfer?.types || [])].includes('Files');
    const over = (e) => {
      if (!istDatei(e) || e.defaultPrevented) return;
      const z = dateiFeld(e.target);
      markieren(z?.box || null);
      if (z) { e.preventDefault(); e.dataTransfer.dropEffect = 'copy'; }
    };
    const weg = () => markieren(null);
    const raus = (e) => { if (!e.relatedTarget) weg(); };
    const drop = (e) => {
      markieren(null);
      if (!istDatei(e) || e.defaultPrevented) return;
      const z = dateiFeld(e.target);
      if (!z) return;
      e.preventDefault();
      let dateien = [...e.dataTransfer.files].filter((f) => passt(f, z.input.accept));
      if (!z.input.multiple) dateien = dateien.slice(0, 1);
      if (!dateien.length) { window.alert('Dieser Dateityp wird hier nicht angenommen.'); return; }
      const dt = new DataTransfer();
      dateien.forEach((f) => dt.items.add(f));
      z.input.files = dt.files;
      z.input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    document.addEventListener('dragover', over);
    document.addEventListener('drop', drop);
    document.addEventListener('dragend', weg);
    window.addEventListener('dragleave', raus);
    return () => { document.removeEventListener('dragover', over); document.removeEventListener('drop', drop); document.removeEventListener('dragend', weg); window.removeEventListener('dragleave', raus); };
  }, []);
  return null;
};

export default DateiFelderDrop;
